var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import LabelValue from '@/components/LabelValue.vue';
let EditTopicForAllDialog = class EditTopicForAllDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.selectedLevel = '';
        this.selectedPeriod = '';
        // #endregion
        // #region Async methods (api calls only)
        // #endregion
        // #region Getters & Setters
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    onClose() {
        this.$emit('close');
    }
    onCancel() {
        this.selectedLevel = '';
        this.selectedPeriod = '';
        this.$emit('close');
    }
    onSubmit() {
        const payload = {
            topicId: this.selectedTopic.value,
            levelId: this.selectedLevel,
            periodId: this.selectedPeriod,
        };
        this.$emit('submit', payload);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof Record !== "undefined" && Record) === "function" ? _a : Object)
], EditTopicForAllDialog.prototype, "selectedTopic", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], EditTopicForAllDialog.prototype, "levels", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Array)
], EditTopicForAllDialog.prototype, "periods", void 0);
EditTopicForAllDialog = __decorate([
    Component({
        components: {
            LabelValue,
        }
    })
], EditTopicForAllDialog);
export default EditTopicForAllDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
